module.exports = __webpack_public_path__ + "static/media/car7.e23d132d.png";